module.exports = __webpack_public_path__ + "d4fa6f9cc71e0637e1c2fbf5a5c2ccb8.svg";